import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function Solitaire() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Solitaire" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Solitaire</h1>
      <img
        src="/thumbnails/Solitaire.png"
        alt="Solitaire game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Solitaire</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Solitaire is a classic single-player card game where the goal is to move all cards to foundation piles, sorting them by suit and rank. It’s a relaxing and strategic game enjoyed by millions worldwide.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">History of Solitaire</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Solitaire, also known as Klondike or Patience, has been around since the late 19th century. Napoleon Bonaparte was said to have played a version of it during his exile. By the late 1800s, Solitaire was a mainstream pastime. In Europe, it is referred to as "Patience," while in the United States, "Solitaire" is the more common name. 
          </p>
          <p className="text-gray-700 dark:text-gray-300 mt-4">The game gained massive popularity with the advent of personal computers, especially after being included in Microsoft Windows in the 1990s. Today, it remains one of the most beloved card games, available on countless platforms and enjoyed by players of all ages.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Arrange cards in descending order and alternating colors on the tableau.</li>
          <li>Move cards to the foundation piles, starting with the Ace and building up by suit.</li>
          <li>Only Kings can be placed in empty tableau spaces.</li>
          <li>Draw cards from the stock pile when no moves are available.</li>
          <li>Win by moving all cards to the foundations.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Classic Klondike Solitaire rules</li>
          <li>Undo and hint options</li>
          <li>Beautiful card graphics and smooth animations</li>
          <li>Track your stats and best times</li>
          <li>Relaxing gameplay for all ages</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Expose hidden cards on the tableau as soon as possible.</li>
          <li>Don’t automatically move cards to the foundation—sometimes you’ll need them for moves on the tableau.</li>
          <li>Use the undo button to experiment with different strategies.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Solitaire</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Play Solitaire for free—no download or registration required. Challenge yourself and see how quickly you can win!
        </p>
        <PlayGameLink game="Solitaire" />
      </section>
    </div>
  );
}
